import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';
import React from 'react';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
      postLocalesData={(locales) => {
        // 优先顺序：简体中文、繁體中文、英语（en-US 或 en-GB），其余保持原顺序
        const preferred = ['zh-CN', 'zh-TW'];

        // 替换 ca-ES 的 icon 为西班牙国旗
        const patchedLocales = locales.map(l =>
          l.lang === 'ca-ES'
            ? { ...l, icon: 'CAT' }
            : l
        );

        // 找到可用的英语项（优先 en-US，然后 en-GB）
        const hasEnUS = patchedLocales.find((l) => l.lang === 'en-US');
        const hasEnGB = patchedLocales.find((l) => l.lang === 'en-GB');
        if (hasEnUS) preferred.push('en-US');
        else if (hasEnGB) preferred.push('en-GB');

        const picked: any[] = [];
        const seen = new Set();

        // 先加入优先项（如果在原 locales 中存在）
        for (const p of preferred) {
          const item = patchedLocales.find((l) => l.lang === p);
          if (item && !seen.has(item.lang)) {
            picked.push(item);
            seen.add(item.lang);
          }
        }

        // 再追加其余项，保持原顺序且不重复
        for (const item of patchedLocales) {
          if (!seen.has(item.lang)) {
            picked.push(item);
            seen.add(item.lang);
          }
        }

        return picked;
      }}
    />
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://cyberai.top/tech/"
      target="_blank"
      rel="noopener noreferrer"
      title="开发者文档"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
